import { Component } from '@angular/core';

@Component({
  selector: 'app-section-etapas-inovacao',
  templateUrl: './section-etapas-inovacao.component.html',
  styleUrls: ['./section-etapas-inovacao.component.scss'],
})
export class SectionEtapasInovacaoComponent {}
